import type { CommunityTypesListProps } from './types'

const PUBLIC_VALUE = 1
const EXCLUSIVE_VALUE = 3
const OPEN_VALUE = 2
const PAID_VALUE = 4

export enum COMMUNITY_TYPE {
  PUBLIC = PUBLIC_VALUE,
  OPEN = OPEN_VALUE,
  EXCLUSIVE = EXCLUSIVE_VALUE,
  PAID = PAID_VALUE
}

export const ACCESS_ITEMS = {
  paid: {
    title: 'configuration_sidebar.access_and_privacy.paid_access.title_v2',
    description: 'configuration_sidebar.access_and_privacy.paid_access.description_v2'
  },
  open: {
    title: 'configuration_sidebar.access_and_privacy.open_access.title_v2',
    description: 'configuration_sidebar.access_and_privacy.open_access.description_v2'
  },
  exclusive: {
    title: 'configuration_sidebar.access_and_privacy.exclusive_access.title_v2',
    description: 'configuration_sidebar.access_and_privacy.exclusive_access.description_v2'
  },
  public: {
    title: 'configuration_sidebar.access_and_privacy.public_access.title',
    description: 'configuration_sidebar.access_and_privacy.public_access.description'
  }
}

export const COMMUNITY_TYPES_LIST = ({
  showPublicCommunityFlag,
  showPaidCommunityFlag
}: CommunityTypesListProps = {}) => [
  {
    title: ACCESS_ITEMS.public.title,
    description: ACCESS_ITEMS.public.description,
    type: COMMUNITY_TYPE.PUBLIC,
    show: showPublicCommunityFlag
  },
  {
    title: ACCESS_ITEMS.paid.title,
    description: ACCESS_ITEMS.paid.description,
    type: COMMUNITY_TYPE.PAID,
    show: showPaidCommunityFlag
  },
  {
    title: ACCESS_ITEMS.open.title,
    description: ACCESS_ITEMS.open.description,
    type: COMMUNITY_TYPE.OPEN,
    show: true
  },
  {
    title: ACCESS_ITEMS.exclusive.title,
    description: ACCESS_ITEMS.exclusive.description,
    type: COMMUNITY_TYPE.EXCLUSIVE,
    show: true
  }
]
